module.exports = __webpack_public_path__ + "static/media/hero-small-subscribed.9bb13601.webp";